// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminEntry {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f4f4f9;
  }
  
  .login-card, .welcome-card {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 20px;
    width: 300px;
    text-align: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
  
  }
  
  .login-card input {
    width: 90%;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  
  .login-card button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  
  .login-card button:hover {
    background-color: #0056b3;
  }
  
  .welcome-card h2 {
    margin-bottom: 20px;
  }
  .menuButton {
    padding: 10px 20px;
    background-color: rgb(216, 189, 69);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .greenbutton:hover {
    background-color: rgb(41, 164, 51);
  }
  
  .card button {
    padding: 10px 20px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
  }
  input {
    height: 30px;
  }

  .card button:hover {
    background-color: #bd2130;
  }
  .custom-input {
    border: none;
    outline: none;
  }

  .custom-input::placeholder {
    font-size: small;
    color: #999;
  }
 
  @media (max-width: 599px) {
    .card{
      padding: 20px;
    }
    p {
      font-size: 12px;
    }
    img{
      width: 20px;
      height: 20px;
    }
    h1 {
      font-size: 18px;
    }
    th {
      font-size: 12px;
    }
    td {
      font-size: 12px;
    }
  .logo{
    width: 200px;
    height: 80px;
  }
  .reklam{
    width: 60px;
    height: 20px;
  }
  .artisticText{
    font-size: 16;
  }
  }
  
  /* Tabletler için yazı boyutları */
  @media (min-width: 600px) and (max-width: 899px) {
    .card{
      padding: 30px;
    }
    p {
      font-size: 15px;
    }
    img{
      width: 25px;
      height: 25px;
    }
    h1 {
      font-size: 20px;
    }
    th {
      font-size: 15px;
    }
    td {
      font-size: 15px;
    }
    .logo{
      width: 220px;
      height: 100px;
    }
    .reklam{
      width: 80px;
      height: 30px;
    }
    .artisticText{
      font-size: 18;
    }
  }
  
  /* Masaüstü tarayıcılar için yazı boyutları */
  @media (min-width: 900px) {
   
    .login-card,.welcome-card{
        width: 500px;
    }
  }
  
  /* büyük ekranlar için yazı boyutları */
  @media (min-width: 1200px) {
    .card{
      padding: 40px;
    }
    p {
      font-size: 20px;
    }
    img{
      width: 35px;
      height: 35px;
    }
    h1 {
      font-size: 28px;
    }
    th {
      font-size: 20px;
    }
    td {
      font-size: 20px;
    }
    .logo{
      width: 300px;
      height: 120px;
     
    
    }
    .reklam{
      width: 120px;
      height: 40px;
    }
    .artisticText{
      font-size: 22;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/AdminEntry.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,sBAAsB;;EAExB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE;MACE,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;;EAEA,kCAAkC;EAClC;IACE;MACE,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,YAAY;MACZ,aAAa;IACf;IACA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,aAAa;IACf;EACF;;EAEA,6CAA6C;EAC7C;;IAEE;QACI,YAAY;IAChB;EACF;;EAEA,uCAAuC;EACvC;IACE;MACE,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,YAAY;MACZ,aAAa;;;IAGf;IACA;MACE,YAAY;MACZ,YAAY;IACd;IACA;MACE,aAAa;IACf;EACF","sourcesContent":[".AdminEntry {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #f4f4f9;\n  }\n  \n  .login-card, .welcome-card {\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    padding: 20px;\n    width: 300px;\n    text-align: center;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    background-color: #fff;\n  \n  }\n  \n  .login-card input {\n    width: 90%;\n    padding: 10px;\n    margin: 10px 0;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n  }\n  \n  .login-card button {\n    width: 100%;\n    padding: 10px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  \n  .login-card button:hover {\n    background-color: #0056b3;\n  }\n  \n  .welcome-card h2 {\n    margin-bottom: 20px;\n  }\n  .menuButton {\n    padding: 10px 20px;\n    background-color: rgb(216, 189, 69);\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .greenbutton:hover {\n    background-color: rgb(41, 164, 51);\n  }\n  \n  .card button {\n    padding: 10px 20px;\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n  }\n  input {\n    height: 30px;\n  }\n\n  .card button:hover {\n    background-color: #bd2130;\n  }\n  .custom-input {\n    border: none;\n    outline: none;\n  }\n\n  .custom-input::placeholder {\n    font-size: small;\n    color: #999;\n  }\n \n  @media (max-width: 599px) {\n    .card{\n      padding: 20px;\n    }\n    p {\n      font-size: 12px;\n    }\n    img{\n      width: 20px;\n      height: 20px;\n    }\n    h1 {\n      font-size: 18px;\n    }\n    th {\n      font-size: 12px;\n    }\n    td {\n      font-size: 12px;\n    }\n  .logo{\n    width: 200px;\n    height: 80px;\n  }\n  .reklam{\n    width: 60px;\n    height: 20px;\n  }\n  .artisticText{\n    font-size: 16;\n  }\n  }\n  \n  /* Tabletler için yazı boyutları */\n  @media (min-width: 600px) and (max-width: 899px) {\n    .card{\n      padding: 30px;\n    }\n    p {\n      font-size: 15px;\n    }\n    img{\n      width: 25px;\n      height: 25px;\n    }\n    h1 {\n      font-size: 20px;\n    }\n    th {\n      font-size: 15px;\n    }\n    td {\n      font-size: 15px;\n    }\n    .logo{\n      width: 220px;\n      height: 100px;\n    }\n    .reklam{\n      width: 80px;\n      height: 30px;\n    }\n    .artisticText{\n      font-size: 18;\n    }\n  }\n  \n  /* Masaüstü tarayıcılar için yazı boyutları */\n  @media (min-width: 900px) {\n   \n    .login-card,.welcome-card{\n        width: 500px;\n    }\n  }\n  \n  /* büyük ekranlar için yazı boyutları */\n  @media (min-width: 1200px) {\n    .card{\n      padding: 40px;\n    }\n    p {\n      font-size: 20px;\n    }\n    img{\n      width: 35px;\n      height: 35px;\n    }\n    h1 {\n      font-size: 28px;\n    }\n    th {\n      font-size: 20px;\n    }\n    td {\n      font-size: 20px;\n    }\n    .logo{\n      width: 300px;\n      height: 120px;\n     \n    \n    }\n    .reklam{\n      width: 120px;\n      height: 40px;\n    }\n    .artisticText{\n      font-size: 22;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
